import { render, staticRenderFns } from "./ReportDeliveryWidget.vue?vue&type=template&id=0413a948&scoped=true&"
import script from "./ReportDeliveryWidget.vue?vue&type=script&lang=js&"
export * from "./ReportDeliveryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportDeliveryWidget.vue?vue&type=style&index=0&id=0413a948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413a948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0413a948')) {
      api.createRecord('0413a948', component.options)
    } else {
      api.reload('0413a948', component.options)
    }
    module.hot.accept("./ReportDeliveryWidget.vue?vue&type=template&id=0413a948&scoped=true&", function () {
      api.rerender('0413a948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportDeliveryWidget.vue"
export default component.exports